import { render, staticRenderFns } from "./DamageVsPremium.vue?vue&type=template&id=65b86c20&scoped=true&"
import script from "./DamageVsPremium.vue?vue&type=script&lang=js&"
export * from "./DamageVsPremium.vue?vue&type=script&lang=js&"
import style0 from "./DamageVsPremium.vue?vue&type=style&index=0&id=65b86c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b86c20",
  null
  
)

export default component.exports